module.exports = __webpack_public_path__ + "static/img/church_03.f75b5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/church_03.png
// module id = GROY
// module chunks = 0